module.exports = __webpack_public_path__ + "assets/images/ert_sports3.7909a01e08ca5dd7888b9949721aea8f.png";